'use client';
import React from 'react';
import {Dialog, DialogContent, DialogTitle} from './dialog';
import {Button} from './Button';
import {pricing} from '@features/subscription/pricing';

interface TierUpgradeConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isLoading: boolean;
  isAnnual: boolean;
  isTeam?: boolean;
  seatsCount?: number;
  /** Override the "from" price label with the actual billed amount (e.g. "$10/mo") */
  currentPriceLabel?: string;
}

export function TierUpgradeConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  isLoading,
  isAnnual,
  isTeam = false,
  seatsCount = 1,
  currentPriceLabel,
}: TierUpgradeConfirmDialogProps) {
  const tier = isTeam ? pricing.team : pricing.individual;
  const multiplier = isTeam ? seatsCount : 1;
  const intervalLabel = isAnnual ? 'Yearly' : 'Monthly';
  const priceKey = isAnnual ? 'yearly' : 'monthly';
  const priceSuffix = isAnnual ? '/year' : '/mo';
  const prefix = isTeam ? 'Team ' : '';

  const fromPrice = `$${tier.plus[priceKey] * multiplier}`;
  const toPrice = tier.pro[priceKey] * multiplier;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogTitle>Change plan</DialogTitle>
        <div className='flex justify-between'>
          <span className='font-semibold'>Plan</span>
          {prefix}Plus {intervalLabel} → {prefix}Pro {intervalLabel}
        </div>
        <div className='flex justify-between'>
          <span className='font-semibold'>Price</span>
          <span>
            {currentPriceLabel ?? `${fromPrice}${priceSuffix}`} → ${toPrice}
            {priceSuffix}
          </span>
        </div>
        <div className='text-sm text-muted-foreground'>
          Only the difference will be charged. Your unused balance is deducted
          automatically.
        </div>
        <Button disabled={isLoading} onClick={onConfirm}>
          {isLoading ? 'Upgrading…' : 'Confirm upgrade'}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
